import { useState, useEffect } from 'react';
import LegalLayout from './LegalLayout';

function PoliticaPrivacidade() {
  const [html, setHtml] = useState<string | null>(null);
  const [css, setCss] = useState('');

  useEffect(() => {
    fetch('/api/conteudo/pagina/privacidade')
      .then((res) => {
        if (!res.ok) throw new Error();
        return res.json();
      })
      .then((data) => {
        if (data.html && data.html.trim()) {
          setHtml(data.html);
          setCss(data.css || '');
        }
      })
      .catch(() => {});
  }, []);

  if (html) {
    return (
      <LegalLayout>
        <style dangerouslySetInnerHTML={{ __html: css }} />
        <div dangerouslySetInnerHTML={{ __html: html }} />
      </LegalLayout>
    );
  }

  return (
    <LegalLayout>
      <h1>Política de Privacidade</h1>
      <p className="legal-last-updated">Última atualização: Janeiro de 2025</p>

      <p>
        A <strong>Vavassori Designer</strong> está comprometida com a proteção da sua privacidade.
        Esta política descreve como coletamos, utilizamos, armazenamos e protegemos seus dados
        pessoais em nossa plataforma de acompanhamento de obras.
      </p>

      <h2>1. Dados Coletados</h2>
      <p>Coletamos as seguintes informações para fornecer nossos serviços:</p>
      <ul>
        <li>
          <strong>Dados de identificação:</strong> nome completo, e-mail, telefone
        </li>
        <li>
          <strong>Dados de acesso:</strong> credenciais de login, endereço IP, data e hora de
          acesso
        </li>
        <li>
          <strong>Dados de projeto:</strong> informações sobre a obra, cronogramas, etapas e
          atividades
        </li>
        <li>
          <strong>Registros fotográficos:</strong> fotos do canteiro de obras, progresso de etapas
          e apontamentos visuais
        </li>
        <li>
          <strong>Dados de navegação:</strong> cookies essenciais para funcionamento da plataforma
        </li>
      </ul>

      <h2>2. Como Utilizamos seus Dados</h2>
      <p>Seus dados são utilizados exclusivamente para:</p>
      <ul>
        <li>Gerenciamento e acompanhamento de projetos de construção</li>
        <li>Registro e documentação do progresso das obras</li>
        <li>Comunicação sobre atualizações do projeto</li>
        <li>Geração de relatórios de acompanhamento</li>
        <li>Garantia da segurança e integridade da plataforma</li>
      </ul>

      <h2>3. Retenção de Dados</h2>
      <p>
        Os dados relacionados a projetos, incluindo registros fotográficos e relatórios de
        progresso, são mantidos por um período de <strong>5 (cinco) anos</strong> após a conclusão
        da obra, conforme requisitos legais e contratuais do setor de construção civil.
      </p>
      <p>
        Fotografias e documentos são armazenados em servidores seguros com criptografia, backup
        redundante e controle de acesso restrito.
      </p>
      <p>
        Dados de acesso e logs são mantidos por 1 (um) ano para fins de segurança e auditoria.
      </p>

      <h2>4. Compartilhamento de Dados</h2>
      <p>
        Não compartilhamos seus dados pessoais com terceiros para fins comerciais ou publicitários.
        O compartilhamento ocorre apenas:
      </p>
      <ul>
        <li>
          Entre os profissionais envolvidos no mesmo projeto (arquiteto, assistente e cliente)
        </li>
        <li>Quando exigido por lei ou ordem judicial</li>
        <li>
          Com prestadores de serviços essenciais à operação da plataforma (hospedagem, backup)
        </li>
      </ul>

      <h2>5. Seus Direitos</h2>
      <p>Como titular dos dados, você tem direito a:</p>
      <ul>
        <li>
          <strong>Acesso:</strong> solicitar uma cópia dos seus dados pessoais
        </li>
        <li>
          <strong>Correção:</strong> atualizar ou corrigir dados incorretos ou incompletos
        </li>
        <li>
          <strong>Exclusão:</strong> solicitar a remoção dos seus dados, respeitando obrigações
          legais de retenção
        </li>
        <li>
          <strong>Portabilidade:</strong> receber seus dados em formato estruturado
        </li>
        <li>
          <strong>Revogação de consentimento:</strong> retirar o consentimento a qualquer momento
        </li>
      </ul>

      <h2>6. Segurança</h2>
      <p>Adotamos medidas técnicas e organizacionais para proteger seus dados, incluindo:</p>
      <ul>
        <li>Criptografia em trânsito (HTTPS/TLS) e em repouso</li>
        <li>Autenticação segura com tokens JWT</li>
        <li>Controle de acesso baseado em perfis (cliente, arquiteto, assistente)</li>
        <li>Monitoramento e logs de auditoria</li>
        <li>Backups regulares e redundantes</li>
      </ul>

      <h2>7. Contato</h2>
      <p>
        Para dúvidas, solicitações ou exercício de direitos relacionados à privacidade, entre em
        contato conosco:
      </p>
      <p>
        <strong>E-mail:</strong>{' '}
        <a href="mailto:privacidade@vavassoridesigner.com.br">
          privacidade@vavassoridesigner.com.br
        </a>
      </p>
      <p>
        <strong>Empresa:</strong> Vavassori Designer
      </p>
      <p>
        <strong>Localização:</strong> Joinville, SC — Brasil
      </p>

      <h2>8. Alterações nesta Política</h2>
      <p>
        Esta política pode ser atualizada periodicamente. Notificaremos os usuários sobre
        alterações significativas por e-mail ou por meio da plataforma. Recomendamos a consulta
        regular desta página.
      </p>
    </LegalLayout>
  );
}

export default PoliticaPrivacidade;
